import { badgesMockHandler } from '@/features/achievements/api/get-badges';

export const badgesHandlers = [badgesMockHandler];
